export interface ChatbotConfig {
  apiBaseUrl: string;
}

export const DEFAULT_CHATBOT_CONFIG: ChatbotConfig = {
  apiBaseUrl: 'http://localhost:8080/api',
};
